import { Grid, Skeleton, Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessStep } from '../../common/enums/enums';
import WOSignOffComponent from './WOSignOffComponent';
import { WOSignoffGrid } from './WOSignoffGrid';

const skeletonViews = ['vendor'];

const WODetailsSignOffComponent = ({
  data,
  isLoading,
  handleSignOffSave = () => {},
  isManager = false,
  onChangeLoading = () => {},
  amplifyApi = '',
  openSignOffModal = false,
  setOpenSignOffModal = () => {},
  handleSignIn = () => {},
  handleSignOffClose = () => {},
  step = ProcessStep.IN_PROCESS,
}) => {
  const { t } = useTranslation('global');
  const [signOffData, setData] = useState({
    name: '',
    lastName: '',
    notes: '',
    signature: '',
    date: '',
  });

  const handleClose = () => {
    setOpenSignOffModal(false);
    handleSignOffClose(true);
  };

  const handleSave = values => {
    const currentValues = {
      name: values?.name ?? '',
      lastName: values?.lastName ?? '',
      notes: values?.notes ?? '',
      signature: values?.canvasImageUrl ?? '',
    };
    setData(currentValues);
    handleSignOffSave(values);
  };

  useEffect(() => {
    if (data) {
      setData({
        name: data?.name ?? '',
        lastName: data?.lastName ?? '',
        notes: data?.notes ?? '',
        signature: data?.signature ?? '',
        date: data?.date ?? '',
      });
    }
  }, [data]);

  return !isLoading ? (
    <>
      <WOSignOffComponent
        isLoading={isLoading}
        isOpen={openSignOffModal}
        onClose={handleClose}
        onSave={handleSave}
        onChangeLoading={onChangeLoading}
        amplifyApi={amplifyApi}
        signOffData={signOffData}
      />
      <Box
        sx={{
          bgcolor: 'background.paper',
          p: { xs: 2, lg: 4 },
          borderTop: '1px solid',
          borderColor: theme => theme.palette.divider,
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            lg={12}
            style={{
              pointerEvents: 'auto',
              color: 'rgba(0, 0, 0, 0.26)',
            }}
            data-testid="vendor-signoff"
          >
            <Grid container flexDirection="column">
              <Box
                pr={{ xs: 0, lg: 2 }}
                pb={{ xs: 2, lg: 0 }}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '20px',
                  height: '100%',
                  width: '100%',
                }}
              >
                <WOSignoffGrid
                  title={t('signOff.signOffTitle')}
                  name={`${signOffData?.name ?? ''} ${
                    signOffData?.lastName ?? ''
                  }`}
                  notes={signOffData?.notes}
                  signature={signOffData?.signature}
                  date={signOffData?.date}
                  isManager={isManager}
                  handleSignIn={handleSignIn}
                  step={step}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  ) : (
    <Box
      data-testid="skeleton"
      sx={{
        bgcolor: 'background.paper',
        p: { xs: 2, lg: 4 },
        borderTop: '1px solid',
        borderColor: theme => theme.palette.divider,
      }}
    >
      <Grid container>
        {skeletonViews.map(item => {
          return (
            <Grid item xs={12} lg={12} key={item}>
              <Grid
                container
                flexDirection="column"
                sx={
                  item === 'vendor'
                    ? {}
                    : {
                        height: '100%',
                        borderLeft: { xs: 0, lg: 1 },
                        color: theme => theme.palette.divider,
                      }
                }
              >
                <Box
                  pr={{ xs: 0, lg: 1 }}
                  pb={{ xs: 1, lg: 0 }}
                  sx={{ height: '100%' }}
                >
                  <Grid item>
                    <Skeleton variant="text" width={120} />
                  </Grid>
                  <Grid item>
                    <Skeleton variant="rounded" width="100%" height={80} />
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default WODetailsSignOffComponent;
